'use strict';

Object.defineProperty(exports, '__esModule', {
	value: true
});
exports['default'] = ScrollWatcher;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _pubsub = require('pubsub');

var _pubsub2 = _interopRequireDefault(_pubsub);

var _domClasslist = require('dom-classlist');

var _domClasslist2 = _interopRequireDefault(_domClasslist);

function ScrollWatcher() {
	window.addEventListener('scroll', function (e) {
		_pubsub2['default'].emit('window:scroll', window.scrollY);
	});
}

module.exports = exports['default'];
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi9Vc2Vycy9iYWJlL1dvcmsvdjIuZG91YmxlZy51bHRyYW5vaXIuY29tL2Fzc2V0cy9zY3JpcHRzL3BhcnRpYWxzL3Njcm9sbC13YXRjaGVyLmpzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7Ozs7O3FCQUd3QixhQUFhOzs7O3NCQUhsQixRQUFROzs7OzRCQUNMLGVBQWU7Ozs7QUFFdEIsU0FBUyxhQUFhLEdBQUk7QUFDeEMsT0FBTSxDQUFDLGdCQUFnQixDQUFDLFFBQVEsRUFBRSxVQUFTLENBQUMsRUFBRTtBQUM3QyxzQkFBTyxJQUFJLENBQUMsZUFBZSxFQUFFLE1BQU0sQ0FBQyxPQUFPLENBQUMsQ0FBQTtFQUM1QyxDQUFDLENBQUE7Q0FDRiIsImZpbGUiOiIvVXNlcnMvYmFiZS9Xb3JrL3YyLmRvdWJsZWcudWx0cmFub2lyLmNvbS9hc3NldHMvc2NyaXB0cy9wYXJ0aWFscy9zY3JvbGwtd2F0Y2hlci5qcyIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCBwdWJzdWIgZnJvbSAncHVic3ViJztcbmltcG9ydCBjbGFzc0xpc3QgZnJvbSAnZG9tLWNsYXNzbGlzdCc7XG5cbmV4cG9ydCBkZWZhdWx0IGZ1bmN0aW9uIFNjcm9sbFdhdGNoZXIgKCkgeyBcblx0d2luZG93LmFkZEV2ZW50TGlzdGVuZXIoJ3Njcm9sbCcsIGZ1bmN0aW9uKGUpIHtcblx0XHRwdWJzdWIuZW1pdCgnd2luZG93OnNjcm9sbCcsIHdpbmRvdy5zY3JvbGxZKVxuXHR9KVxufSJdfQ==